import { CyclePhases } from "@/female/constants/cycle-based-exp/CyclePhases";
const calculateCyclePhase = ({
    startDate,
    periodDuration,
}: {
    startDate: Date;
    periodDuration: number;
}): CyclePhases => {
    const startDateObj = new Date(startDate);
    const currentDate = new Date();
    const daysPassed = Math.floor(
        (currentDate.getTime() - startDateObj.getTime()) / (1000 * 60 * 60 * 24)
    );
    if (daysPassed <= periodDuration) {
        return CyclePhases.Menstrual;
    } else if (daysPassed <= 10) {
        return CyclePhases.Follicular;
    } else if (daysPassed <= 14) {
        return CyclePhases.Ovulation;
    } else {
        return CyclePhases.Luteal;
    }
};

export default calculateCyclePhase;
